const bazarBn = {
	common: {
		brandLabel: 'ব্র্যান্ড',
		storeLabel: 'দোকান',
		unitCount: 'টি',
	},
	search: {
		placeholders: [
			'পণ্যের নাম লিখুন...',
			'ব্র্যান্ডের নাম লিখুন...',
			'দোকানের নাম লিখুন...',
			'ক্যাটেগরির নাম লিখুন...'
		]
	},
	sidebar: {
		categoriesTitle: 'পণ্যের ধরন',
		storesTitle: 'দোকানের তালিকা',
	},
	store: {
		serviceAreaLabel: 'সেবা এলাকা',
		nationwide: 'সারাদেশ',
		productCount: 'পণ্যের সংখ্যা',
		productsOfSuffix: 'এর পণ্যসমূহ',
		description: 'নিচে দোকানের সকল উপলব্ধ পণ্য দেখানো হয়েছে। আপনি চাইলে ক্যাটেগরি অনুযায়ী ফিল্টার করতে পারেন।',
	},
	buttons: {
		details: 'বিস্তারিত',
		addToCart: 'ব্যাগে নিন',
		clearFilters: 'সব ফিল্টার মুছুন',
		close: 'বন্ধ করুন',
	},
	empty: {
		title: 'কোন পণ্য পাওয়া যায়নি',
		subtitle: 'অনুগ্রহ করে আপনার ফিল্টার বা সার্চ পরিবর্তন করুন',
	},
};

export default bazarBn;


